import React, { Component } from "react";
import { Image, Col, Row, FormCheck } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  Container,
  Header,
  Heading,
  Radio,
  RadioGroup,
  SelectPicker,
  InputNumber,
  Button,
  Input,
  DateInput,
  Text,
  Badge,
  Message,
  toaster,
  InputGroup,
  Modal,
} from "rsuite";
import "../Entities/style.css";
import axios from "../axiosIn";
import { variables } from "../Variables";
import SearchIcon from "@rsuite/icons/Search";

export class Registro extends Component {
  constructor(props) {
    super(props);

    this.myRef = React.createRef();

    // SE REDIRIGE A HOME SE UTILIZA PARA EL CIERRE DEL REGISTRO
    // window.location.href = "/Home";

    const _window = window.location.href;
    let _param = [];
    _param = _window.split("=");
    let _esTutor = 0;

    if (_param.length > 1) {
      _esTutor = _param[2].trim();
    }

    this.state = {
      idLiga: 1,
      tipoInsc: "1",
      tipoReg: "1",
      categoria: "",
      categorias: [{ label: "", value: "" }],
      tallas: [
        { label: "S - Chica", value: "S - Chica" },
        { label: "M - Mediana", value: "M - Mediana" },
        { label: "L - Grande", value: "L - Grande" },
        { label: "Extra grande", value: "XL - Extra Grande" },
        { label: "Doble Ex Grande", value: "XXL - Doble Ex Gde." },
      ],
      dataRegistro: [
        { label: "Individual", value: "1" },
        { label: "Por Grupo", value: "2" },
      ],
      formaPagos: [
        {
          label: "Transferencia electrónica de fondos",
          value: "03 - Transferencia electrónica de fondos",
        },
      ],
      disabledReg: true,
      fileFoto: null,
      fileComprob: null,
      showCard1: "none",
      showCard2: "none",
      errNombre: "",
      errEquipo: "",
      errFecNac: "",
      errCurp: "",
      errProc: "",
      errCelular: "",
      errForma: "",
      errCategoria: "",
      errComprob: "",
      errFoto: "",
      num: 1,
      disTalla: true,
      precio: this.getCookie("precio"),
      resultCurpOk: "none",
      resultCurpErr: "none",
      showLabelPrice: "none",
      lblPrecio: "El precio por inscripción es de ",
      colorCurp: "#4caf50",
      msjValidacion: "",
      error: "",
      msjOk: "Se ha registrado, de forma correcta.",
      displayMsjOk: "none",
      disabledOk: false,
      categoriaDisabled: true,
      disabledFoto: false,
      curpValidada: false,
      disabledComprob: false,
      curp: "",
      fecha: "",
      nombre: "",
      categoria: "",
      fecNac: "",
      clave: "",
      curp: "",
      equipo: "",
      tel: "",
      procedencia: "",
      esTutor: _esTutor,
      tutor: "",
      pista: this.getCookie("pista"),
      textoFecha: this.getCookie("fecha"),
      ubicacion: this.getCookie("ubicacion"),
      optionsLista: [],
      listaBusq: [],
      openModal: false,
      filtro: "",
      mostrarBusqueda: false,
    };
    this.getCierre();
  }

  focusInput = () => {
    this.myRef.current.focus();
  };

  getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  eventoClick() {
    console.log("");
  }

  getCierre = async () => {
    var url = `DatosCarrera/getCierre`;
    await axios
      .get(url)
      .then((res) => {
        if (res.data === 1) {
          window.location.href = "#/CierreEvento";
        }
      })
      .catch((err) => console.error(err));
  };

  getPrecios = async () => {
    var url = `Registro/GetPrecios`;
    await axios
      .get(url)
      .then((res) => {
        let arrayOpt = [];
        res.data.forEach((el) => {
          arrayOpt.push({
            descrip: el.descrip,
            value: el.value,
            precio: el.precio,
          });
        });
        this.setState({ optionsLista: arrayOpt });
      })
      .catch((err) => console.error(err));
  };

  async loadListaCategorias(tipoInsc) {
    var url = `Registro/ListaCategorias/${tipoInsc}`;
    await axios
      .get(url)
      .then((res) => {
        let _categos = [{ label: "", value: "" }];
        res.data.map((c) =>
          _categos.push({
            label: `${c.NomCategoria} (${c.IdCategoria})`,
            value: c.IdCategoria,
          }),
        );
        this.setState({ categorias: _categos });
      })
      .then((next) => {
        this.getPrecios();
      })
      .catch((err) => console.error(err));
  }

  componentDidMount() {
    this.loadListaCategorias(1);
  }

  validEntity(values) {
    var nombre = values.nombre;
    var equipo = values.equipo;
    var foto = values.foto;
    var _categoria = values.categoria;
    var fecNac = values.fecNac;
    var curp = values.curp;
    var celular = values.celular;
    var procedencia = values.procedencia;

    var errors = false;

    if (!nombre) {
      this.setState({ errNombre: "* Este campo es requerido" });
      errors = true;
    } else {
      this.setState({ errNombre: "" });
    }

    if (!equipo) {
      this.setState({ errEquipo: "* Este campo es requerido" });
      errors = true;
    } else {
      this.setState({ errEquipo: "" });
    }

    if (!_categoria) {
      this.setState({ errCategoria: "* Este campo es requerido" });
      errors = true;
    } else {
      this.setState({ errCategoria: "" });
    }

    if (!fecNac) {
      this.setState({ errFecNac: "* Este campo es requerido" });
      errors = true;
    } else {
      this.setState({ errFecNac: "" });
    }

    if (!curp) {
      this.setState({ errCurp: "* Este campo es requerido" });
      errors = true;
    } else {
      this.setState({ errCurp: "" });
    }

    if (!procedencia) {
      this.setState({ errProc: "* Este campo es requerido" });
      errors = true;
    } else {
      this.setState({ errProc: "" });
    }

    if (!celular) {
      this.setState({ errCelular: "* Este campo es requerido" });
      errors = true;
    } else {
      this.setState({ errCelular: "" });
    }

    if (!this.state.edadValida) {
      this.setState({
        errCategoria: "* Categoría incorrecta de acuerdo a edad",
      });
      errors = true;
    } else {
      this.setState({ errCategoria: "" });
    }

    return errors;
  }

  async saveEntity(values) {
    var _comprob = values.comprobante;
    var foto = values.foto;
    var _formPago = values.formaPago;
    var _validate = this.validEntity(values);

    console.log("Validate::: ", _validate);
    if (_validate) {
      this.setState({ disabledOk: false });
      return;
    }

    if (!_formPago) {
      this.setState({ errForma: "Debe seleccionar una forma de pago" });
      this.setState({ disabledOk: false });
      return;
    } else {
      this.setState({ errForma: "" });
    }

    if (
      _formPago !== "01 - Efectivo" &&
      this.state.fileComprob === null &&
      this.state.tipoInsc !== "4"
    ) {
      this.setState({ errComprob: "Debe adjuntar el pago" });
      this.setState({ disabledOk: false });
      return;
    } else {
      this.setState({ errComprob: "" });
    }

    if (!this.state.disabledFoto && foto.size === 0) {
      this.setState({ disabledOk: false });
      this.setState({ errFoto: "Debe adjuntar una fotografía" });
      return;
    }

    if (!this.state.curpValidada) {
      this.toast("El formato de la curp no es valido.", "error");
      this.setState({ disabledOk: false });
      return;
    }

    console.log("Grabando...");
    fetch(variables.API_URL + "Registro/SaveEntity", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        nombre: values.nombre,
        equipo: values.equipo,
        categoria: values.categoria,
        curp: values.curp,
        fecNac: values.fecNac,
        formaPago: this.state.tipoInsc === "4" ? "Sin Pago" : values.formaPago,
        foto: !this.state.disabledFoto ? values.foto.name : "SinFoto.jpg",
        comprobante:
          this.state.fileComprob !== null ? this.state.fileComprob.name : "",
        celular: values.celular,
        procedencia: values.procedencia,
        tipoInsc: this.state.tipoInsc,
        talla: values.talla,
        responAceptada: 1,
        nombreTutor: this.state.tutor,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result === -3) {
            this.toast("La CURP que intenta registrar, ya existe.", "warning");
            this.setState({ disabledOk: false });
            return;
          }
          if (result !== "") {
            console.log("Saved");
            this.saveFiles(result, values.formaPago);
          } else {
            this.setState({ disabledOk: false });
            alert("Valide la información, datos incompletos.");
          }
        },
        (error) => {
          this.setState({ disabledOk: false });
          alert("Ocurrio un error");
        },
      );
  }

  async calcularPrecio() {
    const abortController = new AbortController();
    var _idLiga = this.state.idLiga;
    var _tipoInsc = this.state.tipoInsc;
    var _tipoReg = this.state.tipoReg;
    var _num = this.state.num;

    var url = `Registro/GetFinalPrice/${_idLiga}/${_tipoInsc}/${_tipoReg}/${_num}`;

    try {
      const response = await axios.get(url, { signal: abortController.signal });
      this.setState({ showLabelPrice: "block" });
      this.setState({ precio: response.data.precioFin });
      var _precio = response.data.precioFinal;
      this.setState({ lblPrecio: `${response.data.msj}${_precio}` });
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        this.toast("Ha ocurrido un error", "error");
      }
    }
  }

  validaAniosCatego = async (idCatego) => {
    var url = `Registro/ValidaCategoFecNac/${idCatego}/${this.state.curp}`;

    await axios
      .get(url)
      .then((response) => {
        if (response.data.validacion === 0) {
          var edadMax = response.data.max;
          var msj = `La edad de esta categoría, se debe encontrar entre los ${response.data.min} y ${edadMax.toFixed(0)} años.`;
          if (edadMax === 0) {
            msj = `La edad inicial debe ser a partir de los ${response.data.min} años.`;
          }
          this.setState({ edadValida: false });
          this.toast(msj, "error");
        } else {
          this.setState({ edadValida: true });
          this.setState({ errCategoria: "" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleChange = (event) => {
    this.setState({ tipoReg: event });
    if (event === "2") {
      this.setState({ disabledReg: false });
    } else {
      this.setState({ disabledReg: true });
    }
  };

  handleChangeTipoInsc = (event) => {
    this.setState({ curp: "" });
    this.setState({ resultCurpOk: "none" });
    this.setState({ msjValidacion: "" });
    this.setState({ nombre: "" });
    this.setState({ clave: "" });
    this.setState({ categorias: [] });

    this.loadListaCategorias(event.target.value);
    this.setState({ tipoInsc: event.target.value });
    this.setState({ showCard1: "none" });
    this.setState({ showCard2: "none" });

    if (event.target.value === "3") {
      let _claves = [{ label: "Parejas", value: "VL" }];
      this.setState({ categorias: _claves });
      this.setState({ clave: "VL" });
      this.setState({ categoriaDisabled: true });
    } else {
      this.setState({ categoriaDisabled: true });
    }

    if (event.target.value === "5") {
      this.setState({ disTalla: false });
    } else {
      this.setState({ disTalla: true });
    }

    if (event.target.value === "4") {
      this.setState({ disabledComprob: true });
      this.toast(
        "El registro será validado de acuerdo a la información ingresada.",
        "info",
      );
    } else {
      this.setState({ disabledComprob: false });
    }
  };

  handleChangeNombre = (event) => {
    this.setState({ nombre: event.target.value });
  };

  handleFecNac = (date, event) => {
    this.setState({ fecNac: date });
  };

  clickComenzar = () => {
    if (this.state.esTutor === "1" && !this.state.tutor) {
      this.toast(
        "Debes escribir el nombre del padre o tutor, antes de continuar",
        "error",
      );
      return;
    }
    this.calcularPrecio();
    if (this.state.tipoInsc === "1") {
      this.setState({ showCard1: "block" });
      setTimeout(() => {
        this.focusInput();
      }, 300);
    } else {
      if (this.state.tipoInsc === "2") {
        this.setState({ disTalla: false });
      }
      this.setState({ showCard1: "block" });
      setTimeout(() => {
        this.focusInput();
      }, 300);
    }
    setTimeout(() => {
      this.focusInput();
    }, 300);
  };

  handleFileFoto = (e) => {
    this.setState({ fileFoto: e.target.files[0] });
  };

  handleFileComprob = (e) => {
    this.setState({ fileComprob: e.target.files[0] });
  };

  errorStyles = (errorVisible) => {
    return {
      display: errorVisible ? "block" : "none",
      color: "red",
      marginTop: 6,
    };
  };

  stringToDate(_date, _format, _delimiter) {
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(
      dateItems[yearIndex],
      month,
      dateItems[dayIndex],
    );
    return formatedDate;
  }

  async getDataCurp() {
    const abortController = new AbortController();

    if (!this.state.curpValidada) {
      return;
    }

    var url = `Registro/GetHistoricData/${this.state.curp}`;
    this.setState({ loading: true });

    try {
      await axios
        .get(url, { signal: abortController.signal })
        .then((response) => {
          document.getElementById("foto").value = null;
          document.getElementById("comprobante").value = null;
          this.setState({ fecha: response.data.fecha });
          this.setState({ nombre: response.data.nombre });
          this.setState({ categoria: response.data.categoria });
          this.setState({ equipo: response.data.equipo });
          this.setState({ clave: response.data.clave });
          this.setState({ procedencia: response.data.procedencia });
          this.setState({ tel: response.data.tel });

          this.validaAniosCatego(response.data.clave);

          if (this.state.tipoInsc !== "3") {
            this.setState({ categoriaDisabled: true });
          } else {
            this.setState({ categoriaDisabled: false });
          }
          var _fecNac = this.stringToDate(
            response.data.fecNac,
            "dd/MM/yyyy",
            "/",
          );
          this.setState({ fecNac: _fecNac });
        })
        .catch((err) => {
          this.toast("La CURP no existe, en el padrón de registrados.");
          document.getElementById("foto").value = null;
          document.getElementById("comprobante").value = null;
          this.setState({ fecNac: null });
          this.setState({ nombre: "" });
          this.setState({ categoria: "" });
          this.setState({ equipo: "" });
          this.setState({ clave: "" });
          this.setState({ procedencia: "" });
          this.setState({ tel: "" });
          this.setState({ categoriaDisabled: false });
        });
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        this.toast("Ha ocurrido un error", "error");
      }
    }
  }

  curpValida = (curp) => {
    var re =
        /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
      validado = curp.match(re);

    this.setState({ resultCurpOk: "block" });

    if (!validado) {
      //Coincide con el formato general?
      this.setState({ msjValidacion: "Formato: Incorrecto" });
      document.getElementById("foto").value = null;
      document.getElementById("comprobante").value = null;
      this.setState({ curpValidada: false });
      this.setState({ colorCurp: "red" });
      this.setState({ fecNac: null });
      this.setState({ nombre: "" });
      this.setState({ categoria: "" });
      this.setState({ equipo: "" });
      this.setState({ clave: "" });
      this.setState({ procedencia: "" });
      this.setState({ tel: "" });
      return false;
    } else {
      this.setState({ msjValidacion: "Formato: Valido" });
      this.setState({ curpValidada: true });
      this.setState({ colorCurp: "#4caf50" });
    }

    //Validar que coincida el dígito verificador
    function digitoVerificador(curp17) {
      //Fuente https://consultas.curp.gob.mx/CurpSP/
      var diccionario = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
        lngSuma = 0.0,
        lngDigito = 0.0;
      for (var i = 0; i < 17; i++)
        lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
      lngDigito = 10 - (lngSuma % 10);
      if (lngDigito === 10) return 0;
      return lngDigito;
    }

    console.log("Validado TRUE");
    if (validado[2] !== digitoVerificador(validado[1])) return false;

    return true; //Validado
  };

  async saveFiles(curp, pago) {
    const formData = new FormData();
    formData.append("comprobante", this.state.fileComprob);
    formData.append("foto", this.state.fileFoto);
    formData.append("curp", curp);
    formData.append("forma", pago);

    await axios
      .post(variables.API_URL + "Registro/SaveFiles", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
         console.log("Saved files");
        this.setState({ displayMsjOk: "block" });
        setTimeout(() => {
          window.location = `/#/registro/respuesta/curp=${curp}`;
          localStorage.setItem("curp", curp);
          // window.location = `/#/registro/confirmado/curp=${curp}`;
        }, 2000);
      });
  }

  async getBusqueda() {
    var url = `Registro/GetBusqueda/${this.state.filtro}`;

    await axios
      .get(variables.API_URL + url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        this.setState({ listaBusq: res.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    var data = new FormData(event.target);
    let formObject = Object.fromEntries(data.entries());

    this.setState({ disabledOk: true });
    this.saveEntity(formObject);
  };

  clikConFoto(event) {
    this.setState({ disabledFoto: !event.target.checked });
    if (!event.target.checked) {
      this.setState({ errFoto: "" });
    }
  }

  handleInputCurp = (e) => {
    var newValue = e.target.value.toUpperCase();
    this.setState({ curp: newValue });
  };

  toast(msg, type = "info") {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  }

  setNombre(value) {
    this.setState({ nombre: value });
  }

  setTutor(value) {
    this.setState({ tutor: value });
  }

  setCategorias(value) {
    this.setState({ clave: value });
    if (value != null) {
      this.validaAniosCatego(value);
    }
  }

  setFecNac(value) {
    this.setState({ fecNac: value });
  }

  setEquipo(value) {
    this.setState({ equipo: value });
  }

  setCelular(value) {
    this.setState({ tel: value });
  }

  setProcedencia(value) {
    this.setState({ procedencia: value });
  }

  setFiltro(value) {
    this.setState({ filtro: value });
  }

  handleOpenModal(value) {
    this.setState({ openModal: value });
  }

  _handleKeyDown = (e) => {
    if (e.key === "F2") {
      this.setState({ listaBusq: [] });
      this.setState({ openModal: true });
    }
  };

  _handleEnter = (e) => {
    if (e.key === "Enter") {
      this.getBusqueda();
    }
  };

  selecRegistro(value) {
    this.setState({ curp: value });
    this.curpValida(value);
    this.handleOpenModal(false);
  }

  render() {
    const {
      pista,
      textoFecha,
      ubicacion,
      tipoInsc,
      tipoReg,
      disabledReg,
      disTalla,
      tallas,
      showCard1,
      fileComprob,
      fileFoto,
      formaPagos,
      categorias,
      dataRegistro,
      resultCurpOk,
      lblPrecio,
      showLabelPrice,
      num,
      colorCurp,
      msjValidacion,
      errNombre,
      errEquipo,
      errFecNac,
      errCurp,
      errProc,
      errCelular,
      errFoto,
      errForma,
      errCategoria,
      errComprob,
      msjOk,
      displayMsjOk,
      disabledOk,
      disabledFoto,
      curpValidada,
      disabledComprob,
      categoriaDisabled,
      curp,
      fecha,
      nombre,
      categoria,
      fecNac,
      clave,
      equipo,
      tel,
      procedencia,
      esTutor,
      tutor,
      filtro,
      mostrarBusqueda,
      openModal,
      optionsLista,
      listaBusq,
    } = this.state;

    return (
      <>
        <div
          style={{
            backgroundImage: "url(Images/bikers.jpg)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "800px",
            minHeight: "100%",
            height: "auto",
            position: "fixed",
            top: 0,
            height: "100%",
            width: "100%",
            overflow: "auto",
          }}
        >
          <div className="App">
            <div className="App container">
              <br></br>
              <Modal
                size="md"
                open={openModal}
                onClose={() => this.handleOpenModal(false)}
              >
                <Modal.Header>
                  <Modal.Title>Filtros de busquéda</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="row mb-3">
                    <div className="col-lg-6 col-md-6">
                      <b>Buscar por</b>
                      <InputGroup>
                        <Input
                          placeholder="Nombre, Apellidos o telefono"
                          onChange={(e) => this.setFiltro(e)}
                          onKeyDown={(e) => this._handleEnter(e)}
                        />
                        <InputGroup.Button>
                          <SearchIcon />
                        </InputGroup.Button>
                      </InputGroup>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <table
                        width={"95%"}
                        className="table table-striped table-hover"
                      >
                        <tr>
                          <th>CURP</th>
                          <th>Nombre</th>
                          <th>Equipo</th>
                        </tr>
                        <tbody>
                          {listaBusq.map((el, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <Button
                                    key={`Btn-${index}`}
                                    onClick={() => this.selecRegistro(el.curp)}
                                    appearance="link"
                                  >
                                    {el.curp}
                                  </Button>
                                </td>
                                <td>{el.nombre}</td>
                                <td>{el.equipo}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <br></br>
                </Modal.Body>
                <Modal.Footer>
                  <br></br>
                  <Button
                    onClick={() => this.handleOpenModal(false)}
                    appearance="primary"
                  >
                    Cerrar
                  </Button>
                </Modal.Footer>
              </Modal>
              <Container>
                <Header
                  style={{
                    backgroundColor: "#f9f7f6",
                    padding: "20px",
                    borderRadius: "15px",
                    opacity: 0.9,
                  }}
                >
                  <Row>
                    {/* <Col className="col-lg-3 col-md-3 col-sm-3">
                      <Image
                        src={`Images/Logo.png`}
                        width={"120px"}
                        height={"120px"}
                      />
                    </Col> */}
                    <Col className="col-lg-9 col-md-9 col-sm-9">
                      <p className="lead">
                        <b>Carrera:</b> {textoFecha}, <b>PISTA {pista}</b>{" "}
                        {ubicacion}
                      </p>
                      <p className="lead">Liga de Ciclismo LICIVILLA MTB</p>
                    </Col>
                  </Row>
                </Header>
                <br></br>
                <React.Fragment>
                  <form onSubmit={this.handleSubmit}>
                    <Container style={{ opacity: 0.96 }}>
                      <>
                        <div className="card" style={{ padding: "10px" }}>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-lg-4 col-md-4 col-sm-4">
                                <b>Selecciona el Tipo de Inscripción</b>
                                <RadioGroup
                                  name="opTipoInsc"
                                  inline
                                  defaultValue={tipoInsc}
                                >
                                  {optionsLista.map((el, index) => {
                                    return (
                                      <div key={index}>
                                        <Radio
                                          value={`${el.value}`}
                                          onClick={this.handleChangeTipoInsc}
                                          checked={
                                            el.value === 1 ? true : false
                                          }
                                        >
                                          {el.descrip} <b>{el.precio}</b>
                                        </Radio>
                                      </div>
                                    );
                                  })}
                                  {/* <Radio
                                    value="1"
                                    onClick={this.handleChangeTipoInsc}
                                    checked
                                  >
                                    Solo Inscripción = $270.00
                                  </Radio>
                                  <Radio
                                    value="5"
                                    disabled={true}
                                    onClick={this.handleChangeTipoInsc}
                                  >
                                    Especial Locales
                                  </Radio>
                                  <Radio
                                    value="3"
                                    onClick={this.handleChangeTipoInsc}
                                  >
                                    Especial parejas $400.00
                                  </Radio> */}
                                </RadioGroup>
                              </div>
                              &nbsp;
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Nombre del Padre/Tutor</b>
                                <Input
                                  placeholder="Nombre del padro o tutor"
                                  name="tutor"
                                  id="tutor"
                                  onChange={(e) => this.setTutor(e)}
                                  disabled={
                                    this.state.esTutor === "1" ? false : true
                                  }
                                />
                              </div>
                              &nbsp;
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <br></br>
                                <Button
                                  appearance="primary"
                                  style={{
                                    width: "100%",
                                    backgroundColor: "blue",
                                  }}
                                  onClick={this.clickComenzar}
                                >
                                  Comenzar
                                </Button>
                              </div>
                              &nbsp;
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <br></br>
                                <Link
                                  className="btn btn-primary w-100"
                                  to="/Registro/DescargaCarta"
                                >
                                  Descargar responsiva
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br></br>
                        <div
                          className="card"
                          id="card1"
                          style={{ padding: "10px", display: `${showCard1}` }}
                        >
                          <div
                            className="card-body"
                            ref={this.myRef}
                            tabIndex={0}
                          >
                            <div className="row mb-3">
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>CURP</b>
                                <InputGroup>
                                  <Input
                                    placeholder="CURP"
                                    id="curp"
                                    name="curp"
                                    maxLength={18}
                                    onChange={this.curpValida}
                                    onInput={this.handleInputCurp}
                                    onKeyDown={this._handleKeyDown}
                                    value={curp}
                                    // SOLO SE ACTIVARA A PARTIR DE LA SEGUNDA CARRERA
                                    onBlur={() => this.getDataCurp()}
                                  />
                                  {mostrarBusqueda ? (
                                    <InputGroup.Button>
                                      <SearchIcon
                                        onClick={() =>
                                          this.handleOpenModal(true)
                                        }
                                      />
                                    </InputGroup.Button>
                                  ) : (
                                    ""
                                  )}
                                </InputGroup>
                                {errCurp && (
                                  <p style={{ color: "red" }}>{errCurp}</p>
                                )}
                                <Badge
                                  style={{
                                    background: `${colorCurp}`,
                                    color: "white",
                                    width: "100%",
                                    display: `${resultCurpOk}`,
                                  }}
                                >
                                  {msjValidacion}
                                </Badge>
                              </div>
                              <div className="col-lg-4 col-md-4 col-sm-4">
                                <b>Nombre</b>
                                <Input
                                  placeholder="Nombre"
                                  name="nombre"
                                  id="nombre"
                                  value={this.state.nombre}
                                  onChange={(e) => this.setNombre(e)}
                                />
                                {errNombre && (
                                  <p style={{ color: "red" }}>{errNombre}</p>
                                )}
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>Categoría</b>
                                <SelectPicker
                                  id="categoria"
                                  name="categoria"
                                  data={categorias}
                                  value={clave}
                                  onChange={(e) => this.setCategorias(e)}
                                  searchable
                                  block
                                  placeholder="Selecciona"
                                />
                                {errCategoria && (
                                  <p style={{ color: "red" }}>{errCategoria}</p>
                                )}
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Fecha de nacimiento</b>
                                <DateInput
                                  format="dd/MM/yyyy"
                                  id="fecNac"
                                  name="fecNac"
                                  value={this.state.fecNac}
                                  onChange={(e) => this.setFecNac(e)}
                                />
                                {errFecNac && (
                                  <p style={{ color: "red" }}>{errFecNac}</p>
                                )}
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>Equipo</b>
                                <Input
                                  placeholder="Nombre del equipo"
                                  id="equipo"
                                  name="equipo"
                                  value={this.state.equipo}
                                  onChange={(e) => this.setEquipo(e)}
                                />
                                {errEquipo && (
                                  <p style={{ color: "red" }}>{errEquipo}</p>
                                )}
                              </div>
                              <div className="col-lg-4 col-md-4 col-sm-4">
                                <b>Adjuntar comprobante de pago</b>
                                <input
                                  type="file"
                                  id="comprobante"
                                  name="comprobante"
                                  accept=".jpg"
                                  onChange={this.handleFileComprob}
                                  disabled={disabledComprob}
                                />
                                <Text
                                  color="red"
                                  size="sm"
                                  style={{ display: `${showLabelPrice}` }}
                                >
                                  {lblPrecio}
                                </Text>
                                {errComprob && (
                                  <p style={{ color: "red" }}>{errComprob}</p>
                                )}
                              </div>
                              <div className="col-lg-4 col-md-4 col-sm-4">
                                <FormCheck
                                  type="checkbox"
                                  defaultChecked
                                  id="conFoto"
                                  label="Adjuntar foto"
                                  style={{ fontWeight: 800 }}
                                  onChange={(e) => this.clikConFoto(e)}
                                />
                                <input
                                  type="file"
                                  id="foto"
                                  name="foto"
                                  accept=".jpg"
                                  disabled={disabledFoto}
                                  onChange={this.handleFileFoto}
                                />
                                {errFoto && (
                                  <p style={{ color: "red" }}>{errFoto}</p>
                                )}
                              </div>
                            </div>
                            <div className="row mb-3">
                              {/* <div
                                className="col-lg-2 col-md-2 col-sm-2"
                              >
                                <b>Talla</b>
                                <SelectPicker
                                  id="talla"
                                  name="talla"
                                  data={tallas}
                                  searchable
                                  style={{ width: "100%" }}
                                  placeholder="Selecciona"
                                  disabled={disTalla}
                                />
                              </div> */}
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>Procedencia</b>
                                <Input
                                  id="procedencia"
                                  name="procedencia"
                                  placeholder="Procedencia"
                                  value={this.state.procedencia}
                                  onChange={(e) => this.setProcedencia(e)}
                                />
                                {errProc && (
                                  <p style={{ color: "red" }}>{errProc}</p>
                                )}
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Número de celular</b>
                                <Input
                                  id="celular"
                                  name="celular"
                                  placeholder="Celular"
                                  value={this.state.tel}
                                  onChange={(e) => this.setCelular(e)}
                                  maxLength={12}
                                />
                                {errCelular && (
                                  <p style={{ color: "red" }}>{errCelular}</p>
                                )}
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>Forma de pago</b>
                                <SelectPicker
                                  data={formaPagos}
                                  id="formaPago"
                                  name="formaPago"
                                  block
                                  searchable={false}
                                  placeholder="Selecciona"
                                />
                                {errForma && (
                                  <p style={{ color: "red" }}>{errForma}</p>
                                )}
                              </div>
                              <div className="col-lg-1 col-md-1 col-sm-1">
                                <br></br>
                                <Button
                                  appearance="primary"
                                  color="green"
                                  style={{ width: "100%" }}
                                  type="submit"
                                  disabled={disabledOk}
                                >
                                  Enviar
                                </Button>
                              </div>
                            </div>
                            <div
                              className="row"
                              style={{ display: `${displayMsjOk}` }}
                            >
                              <div className="col">
                                <center>
                                  <Message showIcon type="info" centered>
                                    {msjOk}
                                  </Message>
                                </center>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    </Container>
                  </form>
                </React.Fragment>
              </Container>
            </div>
          </div>
        </div>
      </>
    );
  }
}
